import { MediaElementAudioPlayer, StubAudioPlayer } from 'utils/audio';
import { TIMEUPDATE_POLLING_INTERVAL_MILLIS } from '../constants';
import { AudioPlayerFactory } from '../features/types';

export const mediaElementAudioPlayerFactory: AudioPlayerFactory = (el) =>
  new MediaElementAudioPlayer(el, {
    timeupdateIntervalMillis: TIMEUPDATE_POLLING_INTERVAL_MILLIS,
  });

export const stubAudioPlayerFactory: AudioPlayerFactory = (el) =>
  new StubAudioPlayer(el.src);
